import { render, staticRenderFns } from "./wallet_list.vue?vue&type=template&id=c7334be8&scoped=true"
import script from "./wallet_list.vue?vue&type=script&lang=js"
export * from "./wallet_list.vue?vue&type=script&lang=js"
import style0 from "./wallet_list.vue?vue&type=style&index=0&id=c7334be8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7334be8",
  null
  
)

export default component.exports